"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _useEventCallback = _interopRequireDefault(require("@restart/hooks/useEventCallback"));
var _CloseButton = _interopRequireDefault(require("../../CloseButton"));
var _ModalContext = _interopRequireDefault(require("./ModalContext"));
var _Text = require("../../Elements/Text/Text");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
const AbstractModalHeader = /*#__PURE__*/React.forwardRef(({
  closeLabel,
  closeLabelValue,
  closeVariant,
  closeButton,
  onHide,
  children,
  ...props
}, ref) => {
  const context = (0, _react.useContext)(_ModalContext.default);
  const handleClick = (0, _useEventCallback.default)(() => {
    context == null || context.onHide();
    onHide == null || onHide();
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    ...props,
    children: [children, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "close-area",
      children: [closeLabelValue && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
        type: "body-text",
        content: closeLabelValue
      }), closeButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseButton.default, {
        "aria-label": closeLabel,
        variant: closeVariant,
        onClick: handleClick,
        analytics: props['data-analytics']
      })]
    })]
  });
});
AbstractModalHeader.defaultProps = defaultProps;
var _default = exports.default = AbstractModalHeader;
module.exports = exports.default;